import { createReducer } from "reduxsauce"
import createActions from "helpers/actionCreator"
import { Types as LoaderTypes } from "model/data"

export const { Types, Creators } = createActions("ompnt/modules/analyze-factors-performance", {
  setFactorCategory: {
    props: ["category"],
  },
  setMetricType: {
    props: ["metricType"],
    track: true,
    trackType: "factors-performance-metric-type-selected",
    trackPayload: ({ metricType }) => ({ metricType }),
  },
})

export const DEFAULT_STATE = {
  selectedView: "factorPerformance",
  selectedFactorCategory: "factors",
}

function handleLoadSuccess(state, action) {
  if (action.resource === "portfolio") {
    return { ...DEFAULT_STATE }
  }

  return state
}

function handleSetFactorCategory(state, { category }) {
  return {
    ...state,
    selectedFactorCategory: category,
  }
}

function handleSetMetricType(state, { metricType }) {
  return { ...state, selectedMetricType: metricType }
}

export default createReducer(DEFAULT_STATE, {
  [LoaderTypes.LOAD_SUCCESS]: handleLoadSuccess,
  [Types.SET_FACTOR_CATEGORY]: handleSetFactorCategory,
  [Types.SET_METRIC_TYPE]: handleSetMetricType,
})
